import React, { useRef, useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Loader2, Send, Bot } from 'lucide-react';
import { CRMRespuestasRapidas } from './CRMRespuestasRapidas';

export const ETIQUETAS_HABILITAN_COMPOSER = ['esperando', 'en_curso'];

export function CRMComposer({ conv, onSend, base, headers }) {
  const [draft, setDraft] = useState('');
  const [rrOpen, setRrOpen] = useState(false);
  const pickRef = useRef(null);
  const slash = draft.startsWith('/');
  const insertar = (texto) => {
    setDraft(prev => (prev.startsWith('/') || !prev.trim() ? texto : `${prev}\n${texto}`));
    setRrOpen(false);
  };
  const onChange = (v) => { setDraft(v); if (v.startsWith('/') && !v.includes('\n')) setRrOpen(true); };
  const [sending, setSending] = useState(false);
  const habilitado = ETIQUETAS_HABILITAN_COMPOSER.includes(conv?.etiqueta_crm);
  const ventanaAbierta = !!conv?.ventana_24h_abierta;
  const puedeEscribir = habilitado && ventanaAbierta;

  const enviar = async () => {
    if (!draft.trim() || !puedeEscribir) return;
    setSending(true);
    const ok = await onSend(draft.trim());
    if (ok) setDraft('');
    setSending(false);
  };

  const placeholder = !habilitado
    ? 'El bot está manejando esta conversación'
    : !ventanaAbierta
      ? 'Ventana de 24 h cerrada'
      : 'Escribí un mensaje... ("/" para respuestas rápidas, Enter envía)';

  if ((conv?.etiqueta_crm || 'bot') === 'bot') {
    return (
      <div className="border-t bg-white px-3 py-2 flex items-center gap-2 text-xs text-gray-500" data-testid="crm-composer-bot">
        <Bot className="w-4 h-4 text-gray-400" /> Conversación atendida por el bot · cambiá la etiqueta para responder
      </div>
    );
  }

  return (
    <div className="border-t bg-white" data-testid="crm-composer-wrap">
      <div className="p-3 flex items-end gap-2">
        {!habilitado && <Bot className="w-5 h-5 text-gray-400 shrink-0 mb-2" />}
        <CRMRespuestasRapidas base={base} headers={headers} conv={conv} disabled={!puedeEscribir || sending}
          open={rrOpen} setOpen={setRrOpen} filtro={slash ? draft.slice(1) : ''} onInsert={insertar} pickRef={pickRef} />
        <textarea
          className={`flex-1 border rounded-md px-3 py-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-amber-400 ${puedeEscribir ? '' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
          rows={2}
          placeholder={placeholder}
          value={draft}
          disabled={!puedeEscribir || sending}
          onChange={e => onChange(e.target.value)}
          onKeyDown={e => {
            if (e.key !== 'Enter' || e.shiftKey) return;
            e.preventDefault();
            if (slash && rrOpen) { if (pickRef.current) pickRef.current(); } else enviar();
          }}
          data-testid="crm-composer"
        />
        <Button onClick={enviar} disabled={!puedeEscribir || !draft.trim() || sending}
          data-testid="crm-btn-enviar" className="shrink-0">
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </Button>
      </div>
    </div>
  );
}
